import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';
import Label from '../label';

export const StyledTabContainer = styled.div`
  opacity: 1;
  cursor: pointer;
  text-transform: capitalize;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
`;

export const StyledTab = styled.div`
  padding: 0 18px 7px 18px;
  ${({ isActive }) =>
    isActive
      ? css`
          border-bottom: 3px solid ${palette('background', 2)};
          border-radius: ${key('sizes.gutter.tiny', '10px')} ${key('sizes.gutter.tiny', '10px')} 0 0;
        `
      : css``};
`;

export const StyledLabel = styled(Label)`
  font-size: 16px;
`;
